
export default function ICP() {
  return (
    <a target="blank" href="https://beian.miit.gov.cn/" style={{marin:0,padding:0,width:"100%",display:"block",textAlign:"center",color:"#999"}} >皖ICP备2023013868号</a>
  )
}